import PropTypes from 'prop-types';
import './CustomProgress.css';
import u from '@/assets/u.png';

// eslint-disable-next-line react/prop-types
const CustomProgress = ({ percent, ton, mixNum }) => {
    return (
        <div className="relative w-full h-5 mt-8">
            <div className="w-full h-[23px] rounded-full bg-[#3c3b50]">
                <div
                    className="relative custom-progress-bar rounded-full"
                    style={{ width: `7%` }}
                >
                    <div
                        className="absolute bottom-10 transform -translate-x-1/2 text-base rounded-lg custom-progress-tooltip flex items-center justify-center"
                        style={{ left: '100%' }}
                    >
                        <img src={u} className="h-5 mr-2" alt="u" />
                        <p>0</p>
                        <div className="w-3 h-3 rotate-45 bg-white absolute left-1/2 bottom-[-6px] transform -translate-x-1/2"></div>
                    </div>
                </div>
            </div>

            <div className="flex justify-between text-xs text-white mt-1">
                <span>0</span>
                <span>{mixNum}</span>
            </div>
        </div>
    );
};

CustomProgress.propTypes = {
    percent: PropTypes.number.isRequired,
    ton: PropTypes.number.isRequired,
};

export default CustomProgress;
